var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(this.$store.state.showGlobalLoader)?_c('GlobalLoader',{attrs:{"message":this.$store.state.globalLoaderMessage}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }